import { render } from "./AndroidApplication.vue?vue&type=template&id=4f8cfbbc"
import script from "./AndroidApplication.vue?vue&type=script&lang=js"
export * from "./AndroidApplication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__